import React from 'react'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import { FormattedNumber, FormattedDate, FormattedMessage } from 'react-intl'
import * as routes from 'core/routing/constants/index'
import { Card, Row, Col } from 'core/components/ui'
import { getMileageUnit } from 'core/utils/cultures/unit'

import wizardsShape from 'core/components/wizard/shapes'
import SVG from 'core/components/svg'
import svg from 'assets/svg'
import { greys, font } from 'assets/themes/theme-default'
import { vehicleShape, stockShape } from '../../shapes'

import PriceRender from './PriceRender'
import ImagePlaceholderWrapper from './ImagePlaceholderWrapper'

const VehicleWrapper = styled(Card)`
  &&& {
    box-shadow: none;
    :hover {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
    }
    background: ${greys.light4};
    text-align: center;
  }

  h4 {
    font-size: ${font.size.lg};
    font-weight: ${font.weight.bold};
    color: ${props => props.theme.colors.color2.bg};
  }
  h5 {
    font-size: ${font.size.base};
    font-weight: ${font.weight.base};
    color: ${props => props.theme.colors.color1.bg};
    line-height: 20px;
  }
  h6 {
    font-size: ${font.size.sm};
    font-weight: ${font.weight.base};
    color: ${greys.dark3};
  }

  .ant-card-body {
    height: 100%;
  }
`
const TitlesWrapper = styled.div`
  margin: 10px 0 5px;
  min-height: 105px;
`

const TypeVehicleWrapper = styled.div`
  padding: 3px;
  text-align: center;
  background-color: ${props => props.theme.colors.color2.bg};
  color: ${greys.light4};
  font-size: ${font.size.xs};
  font-weight: ${font.weight.base};
  margin: 0 auto;
  line-height: 18px;
`
const LabelCol = styled(Col).attrs({ span: 20 })`
  font-size: ${font.size.sm};
`

const LabelColLeft = styled(LabelCol)`
  text-align: right;
`
const LabelColRight = styled(LabelCol)`
  text-align: left;
`
const IconCol = styled(Col).attrs({ span: 4 })`
  text-align: center;
`
const StyledSVG = styled(SVG)`
  width: 18px;
  height: 18px;
  fill: ${props => props.theme.colors.color2.bg};
`

const VehicleItem = props => {
  const { setWizards, wizards, history, stock, setStock, vehicle } = props
  const {
    urlImage,
    brand,
    model,
    typeVehicle,
    finishes,
    energy,
    gearBoxType,
    mileage,
    dateOfRegistration
  } = vehicle

  const activateNextStep = () => {
    const aStepsActive = wizards[wizards.activeWizard]

    const nextIndex = aStepsActive.findIndex(step => step.hash === routes.STOCK_VEHICLES_LIST) + 1

    const extendedStep = { ...aStepsActive[nextIndex], isActive: true }

    const extendedSteps = Object.assign([...aStepsActive], {
      [nextIndex]: extendedStep
    })

    const extentedWizards = { ...wizards, aStepsStock: extendedSteps }
    setWizards(extentedWizards)

    history.push(extendedStep.hash)
  }

  const handleClick = item => {
    const extendedStock = {
      ...stock,
      selectedVehicle: item
    }
    setStock(extendedStock)

    activateNextStep()
  }

  const getCardAction = () => {
    const { price } = vehicle

    return <PriceRender price={price && null} />
  }

  const getCardCover = () => {
    // const urlVisuel = `${urlImage}&width=330&height=250&bLayer=0&bCrop=0&FORMAT=2`
    const urlVisuel = urlImage

    return urlImage ? (
      <img alt={`${brand} ${model}`} src={urlVisuel} />
    ) : (
      <ImagePlaceholderWrapper />
    )
  }

  let sTypeVehicle

  switch (typeVehicle) {
    case 0:
      sTypeVehicle = (
        <FormattedMessage
          id="stock-vehicles-list-item-type-1"
          data-test="stock-vehicles-list-vehicleItem-TypeVehicle-0"
        />
      )
      break
    case 1:
      sTypeVehicle = (
        <FormattedMessage
          id="stock-vehicles-list-item-type-2"
          data-test="stock-vehicles-list-vehicleItem-TypeVehicle-1"
        />
      )
      break
    case 2:
      sTypeVehicle = (
        <FormattedMessage
          id="stock-vehicles-list-item-type-3"
          data-test="stock-vehicles-list-vehicleItem-TypeVehicle-2"
        />
      )
      break
    default:
      break
  }

  return (
    <VehicleWrapper
      onClick={() => handleClick(vehicle)}
      hoverable
      cover={getCardCover()}
      actions={[getCardAction()]}
      data-test="component-stock-vehicles-list-vehicleItem"
    >
      {sTypeVehicle && (
        <TypeVehicleWrapper data-test="stock-vehicles-list-vehicleItem-TypeVehicleWrapper">
          {sTypeVehicle}
        </TypeVehicleWrapper>
      )}
      <TitlesWrapper>
        <h4 data-test="stock-vehicles-list-vehicleItem-title-brand">{brand}</h4>
        <h5 data-test="stock-vehicles-list-vehicleItem-title-model">{model}</h5>
        <h6 data-test="stock-vehicles-list-vehicleItem-title-finishes">{finishes}</h6>
      </TitlesWrapper>

      <Row type="flex" gutter={15}>
        {energy && (
          <Col span={12}>
            <Row type="flex" gutter={5}>
              <LabelColLeft data-test="stock-vehicles-list-vehicleItem-energy-label">
                {energy}
              </LabelColLeft>
              <IconCol>
                <StyledSVG
                  svg={svg.gas_pump}
                  data-test="stock-vehicles-list-vehicleItem-energy-svg"
                />
              </IconCol>
            </Row>
          </Col>
        )}

        {gearBoxType && (
          <Col span={12}>
            <Row type="flex" gutter={5}>
              <IconCol>
                <StyledSVG
                  svg={svg.gear_box}
                  data-test="stock-vehicles-list-vehicleItem-gearbox-svg"
                />
              </IconCol>
              <LabelColRight data-test="stock-vehicles-list-vehicleItem-gearbox-label">
                {gearBoxType}
              </LabelColRight>
            </Row>
          </Col>
        )}
      </Row>
      <Row type="flex" gutter={15}>
        {mileage && (
          <Col span={12}>
            <Row type="flex" gutter={5}>
              <LabelColLeft>
                <FormattedNumber
                  value={mileage}
                  data-test="stock-vehicles-list-vehicleItem-mileage-label"
                />{' '}
                {getMileageUnit()}
              </LabelColLeft>
              <IconCol>
                <StyledSVG svg={svg.road} data-test="stock-vehicles-list-vehicleItem-mileage-svg" />
              </IconCol>
            </Row>
          </Col>
        )}
        {dateOfRegistration && (
          <Col span={12}>
            <Row type="flex" gutter={5}>
              <IconCol>
                <StyledSVG
                  svg={svg.calendar}
                  data-test="stock-vehicles-list-vehicleItem-dateRegistration-svg"
                />
              </IconCol>
              <LabelColRight>
                <FormattedDate
                  value={dateOfRegistration}
                  month="numeric"
                  year="numeric"
                  data-test="stock-vehicles-list-vehicleItem-dateRegistration-label"
                />
              </LabelColRight>
            </Row>
          </Col>
        )}
      </Row>
    </VehicleWrapper>
  )
}

VehicleItem.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  setWizards: PropTypes.func.isRequired,
  wizards: wizardsShape.isRequired,
  vehicle: vehicleShape.isRequired,
  setStock: PropTypes.func.isRequired,
  stock: stockShape.isRequired
}

export default withRouter(VehicleItem)
